// @flow

import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { logout, goToDashboardPage } from "ducks/user/actions";
import { getClassName } from "ui-kit/utils/component";
import Submenu from "./submenu";

import MobileNav from "./mobile-nav";

import "./Header.scss";

import logo from "./img/logo.png";
import dashboard from "./img/dashboard.png";
import invest from "./img/invest.png";
import withdraw from "./img/withdraw.png";
import notifications from "./img/notifications.png";
import account from "./img/account.png";

const ccn = getClassName("Header");
const navItems = [
  {
    id: 0,
    value: "Dashboard",
    link: "/dashboard",
    icon: dashboard,
    exact: true
  },
  { id: 1, value: "Invest", link: "/invest", icon: invest },
  { id: 2, value: "Withdraw", link: "/withdraw", icon: withdraw },
  {
    id: 3,
    value: "Notifications",
    link: "/notifications",
    icon: notifications,
    notification: true
  },
  {
    id: 4,
    value: "Account",
    link: "#",
    icon: account,
    exact: true,
    submenu: true
  }
];

type Props = {
  authorized: boolean,
  me: Function,
  logout: Function
};

type StateProps = {
  authorized: boolean,
  user: object,
  lang: string
};

class Header extends Component<Props> {
  state = {
    countNewNotification: 0
  };

  componentWillReceiveProps(next) {
    if (next.user && next.user.countNewNotification >= 0) {
      this.setState({ countNewNotification: next.user.countNewNotification });
    }
  }

  goToDashboard = () => {
    this.props.goToDashboardPage();
  };

  render() {
    const {
      authorized,
      user,
      logout,
      lang,
      intl: { formatMessage }
    } = this.props;

    return (
      <div className={ccn()}>
        <div className={ccn("container")}>
          <div className={ccn("logo")}>
            <div className={ccn("link-home")} onClick={this.goToDashboard}>
              <img src={logo} alt="Logo of Hedged Bitcoin" />
              <span>Hedged Bitcoin</span>
            </div>
          </div>

          <nav className={ccn("navigation")}>
            <ul className={ccn("list")}>
              {navItems.map(item => (
                <li key={item.id} className={ccn("item")}>
                  <NavLink
                    key={item.id}
                    to={`${item.link && item.link !== "#" ? "/" : ""}${
                      item.link && item.link !== "#" ? lang.toLowerCase() : ""
                    }${item.link}`}
                    exact={item.exact}
                    className={ccn("link")}
                  >
                    {formatMessage({
                      id: `hbc.header.menu${item.id}`,
                      defaultMessage: `${item.value}`
                    })}
                  </NavLink>
                  {item.notification ? (
                    this.state.countNewNotification > 0 ? (
                      <span>{this.state.countNewNotification}</span>
                    ) : (
                      user &&
                      user.countNewNotification > 0 && (
                        <span>{user.countNewNotification}</span>
                      )
                    )
                  ) : null}
                  {authorized && item.submenu && (
                    <Submenu
                      logOut={() => {
                        logout();
                      }}
                      name={user && user.name}
                      lang={lang.toLowerCase()}
                    />
                  )}
                </li>
              ))}
            </ul>
          </nav>
          <MobileNav
            items={navItems}
            userData={user}
            isAuthorized={authorized}
            mobileLang={lang}
            logOut={() => {
              logout();
            }}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state): StateProps => ({
  authorized: state.user.authorized,
  logging: state.user.logging,
  user: state.user.info,
  lang: state.user.lang
});

export default injectIntl(
  connect(
    mapStateToProps,
    { logout, goToDashboardPage }
  )(Header)
);



// WEBPACK FOOTER //
// ./src/components/header/Header.js